"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _appcenter = _interopRequireWildcard(require("../@api/appcenter"));
var _collectame = _interopRequireWildcard(require("../@api/collectame"));
var _autodocs = _interopRequireWildcard(require("../@api/autodocs"));
var _workflux = _interopRequireWildcard(require("../@api/workflux"));
var _dokia = _interopRequireWildcard(require("../@api/dokia"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var authModuleFactory = function authModuleFactory(_ref) {
  var app = _ref.app,
    axiosCustomApis = _ref.axiosCustomApis,
    spinnerService = _ref.spinnerService,
    additionalProps = _ref.additionalProps;
  _appcenter["default"].auth.sync();
  additionalProps = additionalProps || {};
  var firebase = _appcenter.firebase;
  switch (app) {
    case 'appcenter-customer':
      firebase = _appcenter.firebase;
      break;
    case 'dokia-newton':
      firebase = _dokia.firebaseNewton;
      break;
    case 'dokia-adesc':
      firebase = _dokia.firebaseAdesc;
      break;
    case 'workflux-portal':
    case 'workflux':
      firebase = _workflux.firebase;
      break;
    case 'collectame':
      firebase = _collectame.firebase;
      break;
    case 'lawdoc':
    case 'autodocs':
      firebase = _autodocs.firebase;
      break;
  }
  var setApiHeader = function setApiHeader(header, value) {
    axiosCustomApis.map(function (api) {
      api.defaults.headers.common[header] = value;
    });
  };
  var setFirebaseToken = function setFirebaseToken(token) {
    setApiHeader('firebase-token', token);
  };
  firebase.auth().onAuthStateChanged(function () {
    //('AUTH CHANGED', user)

    if (!firebase.auth().currentUser) return;
    firebase.auth().currentUser.getIdToken(true)
    // user.getIdToken(true)
    .then(function (token) {
      setFirebaseToken(token);
    });
  });
  var firebaseInstances = {
    collectame: _collectame.firebase,
    autodocs: _autodocs.firebase,
    workflux: _workflux.firebase,
    dokiaAdesc: _dokia.firebaseAdesc,
    dokiaNewton: _dokia.firebaseNewton
  };
  var instanceIntervals = {
    collectameInterval: '',
    autodocsInterval: '',
    workfluxInterval: '',
    dokiaAdescInterval: '',
    dokiaNewtonInterval: ''
  };
  var getIdToken = function getIdToken(key, instance) {
    if (!instance.auth().currentUser) {
      return;
    }
    return instance.auth().currentUser.getIdToken(true).then(function (token) {
      switch (key) {
        case 'appcenter-customer':
          _appcenter["default"].axios().defaults.headers.common['firebase-token'] = token;
          break;
        case 'dokia':
        case 'dokia-newton':
        case 'dokia-adesc':
          _dokia["default"].axios().defaults.headers.common['firebase-token'] = token;
          break;
        case 'workflux':
          _workflux["default"].axios().defaults.headers.common['firebase-token'] = token;
          break;
        case 'collectame':
          _collectame["default"].axios().defaults.headers.common['firebase-token'] = token;
          break;
        case 'lawdoc':
        case 'autodocs':
          _autodocs["default"].axios().defaults.headers.common['firebase-token'] = token;
          break;
        default:
          break;
      }
      return token;
    });
  };
  Object.keys(firebaseInstances).map(function (key) {
    var instance = firebaseInstances[key];
    instance.auth().onAuthStateChanged(function () {
      getIdToken(key, instance);
      clearInterval(instanceIntervals["".concat(key, "Interval")]);
      instanceIntervals["".concat(key, "Interval")] = setInterval(function () {
        getIdToken(key, instance);
      }, 60000);
    });
  });
  var currentAppcenterState = '';
  var postAuth = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(authData) {
      var _yield$Promise$all, _yield$Promise$all2, appCenterToken, dokiaNewtonToken, dokiaAdescToken, workfluxToken, collectameToken, autodocsToken;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return Promise.all([getIdToken('appcenter-customer', _appcenter.firebase), getIdToken('dokia-newton', _dokia.firebaseNewton), getIdToken('dokia-adesc', _dokia.firebaseAdesc), getIdToken('workflux', _workflux.firebase), getIdToken('collectame', _collectame.firebase), getIdToken('autodocs', _autodocs.firebase)]);
          case 2:
            _yield$Promise$all = _context.sent;
            _yield$Promise$all2 = (0, _slicedToArray2["default"])(_yield$Promise$all, 6);
            appCenterToken = _yield$Promise$all2[0];
            dokiaNewtonToken = _yield$Promise$all2[1];
            dokiaAdescToken = _yield$Promise$all2[2];
            workfluxToken = _yield$Promise$all2[3];
            collectameToken = _yield$Promise$all2[4];
            autodocsToken = _yield$Promise$all2[5];
            return _context.abrupt("return", {
              appCenterToken: appCenterToken,
              dokiaNewtonToken: dokiaNewtonToken,
              dokiaAdescToken: dokiaAdescToken,
              workfluxToken: workfluxToken,
              collectameToken: collectameToken,
              autodocsToken: autodocsToken,
              user: authData.user
            });
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function postAuth(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var service = function service(dispatch) {
    _appcenter.store.subscribe(function () {
      var state = _appcenter.store.getState().appcenter;
      var scope = JSON.stringify(state);
      if (currentAppcenterState === scope) return;
      currentAppcenterState = scope;
      var user = JSON.parse(JSON.stringify(state.user));
      var companyToSet = state.company;
      var activePersonalRequest = state.personalAccessRequests.find(function (r) {
        return r.active && r.status == 'accepted' ? r : false;
      });
      if (activePersonalRequest) {
        companyToSet = {
          uid: activePersonalRequest.company,
          name: activePersonalRequest.name,
          deleted: false
        };
        user.companyadmin = true;
        // user.uid = activePersonalRequest.statusResponsible.uid
      }

      //('user.groups', user.groups)

      user.groups = state.groups.filter(function (g) {
        return g.members.indexOf(user.uid) > -1;
      });

      //('user.groups MEMBEROF', user.groups)

      user.permissions = state.permissions || [];
      setApiHeader('company-id', companyToSet.uid);
      user.currentCompany = companyToSet;

      //('STATE TOENS', state.tokens)

      _collectame["default"].axios().defaults.headers.common['company-id'] = companyToSet.uid;
      _autodocs["default"].axios().defaults.headers.common['company-id'] = companyToSet.uid;
      _workflux["default"].axios().defaults.headers.common['company-id'] = companyToSet.uid;
      _dokia["default"].axios().defaults.headers.common['company-id'] = companyToSet.uid;
      var isAuthenticated = !!(state.authenticated && state.user && state.user.uid && user.currentCompany && user.currentCompany.uid);
      var isAuthContextCreated = state.authenticated ? isAuthenticated : state.isAuthContextCreated;
      dispatch({
        type: 'UPDATE',
        state: {
          user: user,
          firebaseUser: {},
          appCenterToken: state.customToken,
          company: companyToSet,
          isAuthenticated: isAuthenticated,
          authenticated: state.authenticated,
          isTaugor: ['UP4NokWIruNoJuDFj51f', '41xFTMkriSuv4ovHLvH1'].includes(state.company.uid),
          isTaugorDev: state.company.uid === '41xFTMkriSuv4ovHLvH1',
          isFranchisee: state.company.isFranchisee,
          isAuthContextCreated: isAuthContextCreated,
          licenses: state.licenses || [],
          users: state.users || []
        }
      });
    });
    return {
      sso: function () {
        var _sso = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(token) {
          var loading, authData, _yield$Promise$all3, _yield$Promise$all4, appCenterToken, dokiaNewtonToken, dokiaAdescToken, workfluxToken, collectameToken, autodocsToken;
          return _regenerator["default"].wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                loading = spinnerService.service(dispatch);
                loading.show();
                _context2.next = 4;
                return _appcenter["default"].auth.app(app, token, false)["finally"](loading.hide);
              case 4:
                authData = _context2.sent;
                console.log('authData', authData);
                _context2.next = 8;
                return Promise.all([getIdToken('appcenter-customer', _appcenter.firebase), getIdToken('dokia-newton', _dokia.firebaseNewton), getIdToken('dokia-adesc', _dokia.firebaseAdesc), getIdToken('workflux', _workflux.firebase), getIdToken('collectame', _collectame.firebase), getIdToken('autodocs', _autodocs.firebase)]);
              case 8:
                _yield$Promise$all3 = _context2.sent;
                _yield$Promise$all4 = (0, _slicedToArray2["default"])(_yield$Promise$all3, 6);
                appCenterToken = _yield$Promise$all4[0];
                dokiaNewtonToken = _yield$Promise$all4[1];
                dokiaAdescToken = _yield$Promise$all4[2];
                workfluxToken = _yield$Promise$all4[3];
                collectameToken = _yield$Promise$all4[4];
                autodocsToken = _yield$Promise$all4[5];
                return _context2.abrupt("return", {
                  appCenterToken: appCenterToken,
                  dokiaNewtonToken: dokiaNewtonToken,
                  dokiaAdescToken: dokiaAdescToken,
                  workfluxToken: workfluxToken,
                  collectameToken: collectameToken,
                  autodocsToken: autodocsToken,
                  user: authData.user
                });
              case 17:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));
        function sso(_x2) {
          return _sso.apply(this, arguments);
        }
        return sso;
      }(),
      login: function () {
        var _login = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(user, password, company) {
          var loading, authData;
          return _regenerator["default"].wrap(function _callee3$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                loading = spinnerService.service(dispatch);
                loading.show();
                _context3.next = 4;
                return _appcenter["default"].auth.app(app, user, password, company)["finally"](loading.hide);
              case 4:
                authData = _context3.sent;
                return _context3.abrupt("return", postAuth(authData));
              case 6:
              case "end":
                return _context3.stop();
            }
          }, _callee3);
        }));
        function login(_x3, _x4, _x5) {
          return _login.apply(this, arguments);
        }
        return login;
      }(),
      loginWithCertificate: function () {
        var _loginWithCertificate = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(cpf, certificate) {
          var loading, authData;
          return _regenerator["default"].wrap(function _callee4$(_context4) {
            while (1) switch (_context4.prev = _context4.next) {
              case 0:
                loading = spinnerService.service(dispatch);
                loading.show();
                _context4.next = 4;
                return _appcenter["default"].auth.appWithCertificate(app, cpf, certificate)["finally"](loading.hide);
              case 4:
                authData = _context4.sent;
                return _context4.abrupt("return", postAuth(authData));
              case 6:
              case "end":
                return _context4.stop();
            }
          }, _callee4);
        }));
        function loginWithCertificate(_x6, _x7) {
          return _loginWithCertificate.apply(this, arguments);
        }
        return loginWithCertificate;
      }(),
      loginWithGoogle: function () {
        var _loginWithGoogle = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(token, company) {
          var loading, authData;
          return _regenerator["default"].wrap(function _callee5$(_context5) {
            while (1) switch (_context5.prev = _context5.next) {
              case 0:
                loading = spinnerService.service(dispatch);
                loading.show();
                _context5.next = 4;
                return _appcenter["default"].auth.appWithGoogle(app, token, company)["finally"](loading.hide);
              case 4:
                authData = _context5.sent;
                return _context5.abrupt("return", postAuth(authData));
              case 6:
              case "end":
                return _context5.stop();
            }
          }, _callee5);
        }));
        function loginWithGoogle(_x8, _x9) {
          return _loginWithGoogle.apply(this, arguments);
        }
        return loginWithGoogle;
      }(),
      loginWithLinkedIn: function () {
        var _loginWithLinkedIn = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(token, company) {
          var loading, authData;
          return _regenerator["default"].wrap(function _callee6$(_context6) {
            while (1) switch (_context6.prev = _context6.next) {
              case 0:
                loading = spinnerService.service(dispatch);
                loading.show();
                _context6.next = 4;
                return _appcenter["default"].auth.appWithLinkedIn(app, token, company)["finally"](loading.hide);
              case 4:
                authData = _context6.sent;
                return _context6.abrupt("return", postAuth(authData));
              case 6:
              case "end":
                return _context6.stop();
            }
          }, _callee6);
        }));
        function loginWithLinkedIn(_x10, _x11) {
          return _loginWithLinkedIn.apply(this, arguments);
        }
        return loginWithLinkedIn;
      }(),
      anonymous: function anonymous() {
        return _appcenter["default"].auth.anonymous(app);
      },
      logout: function logout() {
        var loading = spinnerService.service(dispatch);
        loading.show();
        //('WILL LOG IN')
        return _appcenter["default"].auth.logout()["finally"](loading.hide);
      },
      recoverPassword: function recoverPassword(user) {
        var loading = spinnerService.service(dispatch);
        loading.show();
        return _appcenter["default"].auth.recoverPassword(user)["finally"](function (e) {
          loading.hide();
        });
      },
      setExternalHeader: function setExternalHeader(user) {
        setApiHeader('external-user', user);
      },
      setCompany: function setCompany(company) {},
      validate: {
        recoveryToken: function recoveryToken(token) {
          var loading = spinnerService.service(dispatch);
          loading.show();
          return _appcenter["default"].auth.validate.recoveryToken(token)["finally"](loading.hide);
        }
      },
      update: function update(props) {
        props = props || {};
        dispatch({
          type: 'UPDATE',
          state: _objectSpread({}, props)
        });
      }
    };
  };
  var INIT_STATE = _objectSpread({
    user: {},
    firebaseUser: {},
    appCenterToken: '',
    company: '',
    isAuthenticated: false,
    isTaugor: false,
    isFranchisee: false
  }, additionalProps);
  var reducer = function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INIT_STATE;
    var action = arguments.length > 1 ? arguments[1] : undefined;
    switch (action.type) {
      case 'UPDATE':
        action.state = action.state || {};
        return _objectSpread(_objectSpread({}, state), action.state);
      default:
        return state;
    }
  };
  return {
    reducer: reducer,
    service: service
  };
};
var _default = authModuleFactory;
exports["default"] = _default;